export default __webpack_public_path__ + "static/all-devices-updated-236068492e488e85ad63c9bc7da32d35.webp";